import { render, staticRenderFns } from "./VideoReceiver.vue?vue&type=template&id=4f90718a&scoped=true&"
import script from "./VideoReceiver.vue?vue&type=script&lang=js&"
export * from "./VideoReceiver.vue?vue&type=script&lang=js&"
import style0 from "./VideoReceiver.vue?vue&type=style&index=0&id=4f90718a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f90718a",
  null
  
)

export default component.exports